import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

type UploadContainerProps = {
  $isUploadedLogo?: boolean;
};

export const StyledUploadContainer = styled('label')<UploadContainerProps>(({ $isUploadedLogo }) => ({
  position: 'relative',
  width: '70px',
  height: '70px',
  border: `2px ${$isUploadedLogo ? 'solid' : 'dashed'} ${COLORS.grey400}`,
  borderRadius: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: COLORS.grey500,
  cursor: 'pointer',
}));

export const StyledAdd = styled('span')<UploadContainerProps>(({ $isUploadedLogo }) => ({
  width: $isUploadedLogo ? '32px' : '24px',
  height: $isUploadedLogo ? '32px' : '24px',
  position: 'absolute',
  top: '-5px',
  right: $isUploadedLogo ? '-14px' : '-6px',
  borderRadius: '50%',
  backgroundColor: COLORS.textMain,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: COLORS.white,
}));

export const StyledInput = styled('input')(() => ({
  display: 'none',
}));

export const StyledUploadedLogoWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '32px',
  marginTop: '10px',
}));

export const StyledUploadedLogoContainer = styled('div')(() => ({
  width: '52px',
  height: '45px',
}));

export const StyledUploadedLogo = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '8px',
}));
